import {ym, getAnalyticsId} from './analytics'
import {sensitiveDataCleanerMiddleware} from './middlewares/sensitiveDataCleanerMiddleware'
import pWaterfall from 'p-waterfall'
import {errorLogger} from './errorLogger'
import {withNamespace} from './shared/withNamespace'

/**
 * https://metrika.yandex.ru/dashboard?id=48925235
 *
 * Чтобы включить вывод в консоль, надо открыть страницу с параметром `_ymt_debug=1` или `_ymt_debug=2`\
 * Например: https://vendor.yandex.ru/home?_ymt_debug=1, для отключения `_ymt_debug=0`
 */
export const metrika = withNamespace(
  createLogger(),
  (namespace, event) => [{...event, target: [namespace, event.target].filter(Boolean).join('_')}] as const,
  '_'
)

function createLogger() {
  return (event: MetrikaEvent) =>
    void pWaterfall(
      [
        sensitiveDataCleanerMiddleware<MetrikaEvent>,
        (prev) => {
          ym(getAnalyticsId(), 'reachGoal', prev.target, prev.params)
        }
      ],
      event
    ).catch(onError)
}

function onError(error: unknown) {
  const safeError = error instanceof Error ? error : new Error(`NonError: ${error}`)
  errorLogger({error: safeError, message: 'Metrika'})
  console.error(error)
}

type MetrikaEvent = {
  target: string
  params: Record<string, unknown>
}
